
<div class="window-container">
    <div *ngIf="!isSafari" class="alert-container large">
        <div class="modal-title-action">{{'audio.settings.title' | translate}}</div>
        <div class="audio-test d-flex">
            <div class="d-felx flex-column setting-input audio-device">
                <h2>
                    <span class="iconify" data-icon="mdi:microphone" data-inline="false" data-width="24" data-height="24"  style="color: #6f3974;"></span>
                    {{'audio.settings.microphone' | translate}}
                </h2>
                <select (change)="onMicrophoneChanged($event.target.value)" class="d-inline-block custom-select rounded-pill">
                   <option *ngFor="let device of microphoneDevices" [value]="device.deviceId" [selected]="device.deviceId === selectedMicrophoneId">{{ device.label}}</option>
                </select>

                <button class="btn rounded-pill btn-museum " [disabled]="currentState !== AudioTestState.IDLE || noMicrophone" (click)="onTestMicrophoneClicked()" >
                    {{'audio.settings.test.microphone' | translate }}
                </button>
            </div>
            <div class="d-flex flex-column setting-output audio-device">
                <h2>
                    <span class="iconify" data-icon="mdi:volume-high" data-inline="false" data-width="24" data-height="24"  style="color: #6f3974;"></span>
                    {{'audio.settings.speaker' | translate}}
                </h2>
                <select (change)="onSpeakerChanged($event.target.value)" class="d-inline-block custom-select rounded-pill">
                    <option *ngFor="let device of speakerDevices" [value]="device.deviceId" [selected]="device.deviceId === selectedSpeakerId">{{ device.label}}</option>
                 </select>

                <button class="btn rounded-pill btn-museum " [disabled]="currentState !== AudioTestState.IDLE" (click)="onTestSpeakerClicked()" >
                    {{'audio.settings.test.speaker' | translate}}
                </button>
            </div>
        </div>
        <div class="waves d-flex align-items-center hidden" >
            <div class="wave" *ngFor="let _ of [].constructor(15)"></div>
        </div>
        <div class="info">
            <p *ngIf="currentState === AudioTestState.SPEAKER">{{'audio.settings.info.testing_speaker' | translate }}</p>
            <p *ngIf="!noMicrophone && !noSoundDetected && currentState === AudioTestState.MICROPHONE">{{'audio.settings.info.recording_microphone' | translate }}</p>
            <p *ngIf="!noMicrophone && !noSoundDetected && currentState === AudioTestState.PLAYING_RECORD">{{'audio.settings.info.playing_microphone' | translate }}</p>
            <p class="info-no-sound" *ngIf="noSoundDetected && !noMicrophone">{{'audio.settings.info.microphone_no_sound' | translate }}</p>
            <p class="info-no-sound" *ngIf="noMicrophone">{{'audio.settings.info.no_microphone' | translate }}</p>
        </div>

        <div class="modal-controls">
            <button class="btn btn-modal rounded-pill btn-museum " (click)="onDoneClicked()" >{{'audio.settings.done' | translate}}</button>
        </div>
    </div>


    <div *ngIf="isSafari" class="alert-container">
        <div class="modal-title-action">{{'video.safari.title' | translate}}</div>
        <p style="text-align: center;">{{'video.safari.message' | translate}}</p>
        <div class="modal-controls">
            <button class="btn btn-modal rounded-pill btn-museum " (click)="onDoneClicked()">{{'video.settings.done' |
                translate}}</button>
        </div>
    </div>
</div>

